import styled from 'styled-components';

export const FeaturesGrid = styled.section`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 0;

  svg {
    margin-right: 10px;
  }
`;
